const CATEGORIES = {
    Accessories: [
        'Glasses',
        'Jewelry',
        'Sunglasses',
        'Watch',
        'Other',
    ],
    Beverages: [
        'Red wine',
        'Sauternes wine',
        'White wine',
        'Spirits',
        'Other',
    ],
    Electronics: [
        'Camera',
        'Cell phone',
        'Computer',
        'Headphones',
        'Personal care',
        'Speaker/Audio System',
        'Tablet',
        'TV',
        'Video game/console',
        'Wearable technology',
        'Other',
    ],
    Hobby: [
        'Music gear',
        'Sports gear',
        'Other',
    ],
    Home: [
        'Appliances',
        'Art',
        'Furniture',
        'Garden',
        'Home decor',
        'Tools',
        'Vacuum',
        'Air cooler/heater/purifier',
        'Other',
    ],
    Personal: [
        'Bags',
        'Clothing',
        'Personal care',
        'Shoes',
        'Other',
    ],
    Transport: [
        'Bicycle',
        'Boat',
        'Car',
        'Electric bicycle',
        'Electric scooter',
        'Four wheeler',
        'Moped',
        'Motorcycle',
        'Snowmobile',
        'Vehicle accessory',
        'Other',
    ],
};

export {
    CATEGORIES,
}
